import type { Reroute } from "@sveltejs/kit/hooks";
import { domainRouting, getDomainKey } from "@fergmar/config/domain-routing";

export const reroute: Reroute = ({ url }) => {
	if (url.pathname.startsWith("/_app/immutable/")) return "/__immutable-archive";
	if (url.pathname === "/api/sentry") return url.pathname;
	if (url.pathname === "/api/health") return url.pathname;
	if (url.pathname === "/api/trpc" || url.pathname.startsWith("/api/trpc/")) return url.pathname;
	const key = getDomainKey(url.hostname);
	const destination = key ? domainRouting[key].destination : null;
	if (destination) return `${destination}${url.pathname}`;
	return url.pathname;
};
